<template>
  <section>
    <h1 class="visually-hidden seo-title">احجز مواد دراسية بسهولة</h1>

    <div class="courses-form-section">
      <b-container class="py-5">
        <div v-if="alertCountdown" class="alert-div text-right">
            <b-alert :show="alertCountdown" aria-live="assertive" dismissible fade :variant="alertType"
              @dismiss-count-down="countDownChanged">
              {{ alertText }}
            </b-alert>
            <br><br>
          </div>
        <b-card class="p-3 text-center custom-card">
          
          <!-- showerror -->
          <div v-show="showerror" role="alert" aria-live="assertive" class="alert alert-danger">
            يجب اختيار كل الخانات
          </div>
          
          <b-tabs v-model="selectedCountry" style="display: flex; justify-content: center;" card>
            <b-tab active @click="loadformdata(1)">
              <template #title>
                <img src="../assets/images/egypt-icon.png" alt="علم مصر" class="flag-icon" />
                احجز مواد مصرية
              </template>
            </b-tab>
            <b-tab @click="loadformdata(2)">
              <template #title>
                <img src="../assets/images/saudi-icon.png" alt="علم السعودية" class="flag-icon" />
                احجز مواد سعودية
              </template>
            </b-tab>
          </b-tabs>

          <b-row class="mt-3">
            <b-col md="3">
              <b-form-group label="المرحلة التعليمية">
                <b-form-select :options="educationLevels" v-model="selectedLevel" placeholder="اختر المرحلة"
                  @change="updateGrades"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="الصف الدراسي">
                <b-form-select :options="grades" v-model="selectedGrade" placeholder="اختر الصف"
                  @change="updateTerms"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="الفصل الدراسي">
                <b-form-select :options="terms" v-model="selectedTerm" placeholder="اختر الفصل"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <label>&nbsp;</label>
              <b-button aria-label="ابحث" type="button" class="w-100" variant="brand"
                @click="submitForm">ابحث</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>


    <!-- pageIsLoading/ -->
    <div v-if="pageIsLoading" class="text-center text-brand my-5 py-5 loadingBox">
      <b-spinner class="align-middle"></b-spinner>
    </div>
    <div v-if="filtered && !pageIsLoading" class="courses-list-section">
      <b-container class="pt-2">
        <b-row v-if="courses.length > 0">
          <b-col cols="6" md="4" lg="3" v-for="item in courses" :key="item.id" class="d-flex" style="margin-bottom: 20px;">
            <b-card class="custom-card">
              <img :title="item?.available_course[0]?.name" :src="item.image || placeholderImage" :alt="item.name"
                class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />
              <div class="card-body-box" :title="item?.available_course[0]?.name">
                <b-card-title class="card-title" :title="item?.available_course[0]?.name">{{
                  item?.available_course[0]?.name
                }}</b-card-title>
              </div>
              <div class="card-body-box card-footer-box">
                <course-price v-if="item?.available_course?.length" class="card-price" compact
                  :course="item.available_course[0]" />
                <b-button v-if="item?.available_course.length > 0" aria-label="تفاصيل الدرس"
                  @click="goToRoute('course', item?.available_course[0]?.id)" size="sm"
                  :to="'/course/' + item?.available_course[0]?.id" variant="brand" class="card-action">تفاصيل</b-button>
                <b-button v-else aria-label="تفاصيل الدرس" size="sm" disabled variant="dark" class="card-action">قريبـًا</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <div class="header d-flex align-items-center justify-content-center">
              <div class="flex-grow-1 border-top"></div>
              <h4 class="mx-3 font-weight-bold">لا يوجد مواد</h4>
              <div class="flex-grow-1 border-top"></div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- not filtered -->
    <div v-if="!filtered && !pageIsLoading" class="courses-list-section">

      <!-- ksaTahsiliCourses -->
      <b-container class="pt-0">
        <b-row>
          <b-col>
            <div class="header d-flex align-items-center justify-content-center">
              <div class="flex-grow-1 border-top"></div>
              <h4 class="mx-3 font-weight-bold">المواد التحصيلية</h4>
              <div class="flex-grow-1 border-top"></div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" v-if="ksaTahsiliCourses.length == 0">
            <div class="d-flex align-items-center justify-content-center">
              <h4 class="mx-3 ">لا يوجد مواد</h4>
            </div>
          </b-col>
          <b-col cols="6" md="4" lg="3" v-for="item in ksaTahsiliCourses" :key="item.id" class="d-flex" style="margin-bottom: 20px;">
            <b-card class="custom-card">
              <img :title="item?.available_course[0]?.name" :src="item.image || placeholderImage" :alt="item.name"
                class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />
              <div class="card-body-box" :title="item?.available_course[0]?.name">
                <b-card-title class="card-title" :title="item?.available_course[0]?.name">{{
                  item?.available_course[0]?.name ?? item.name
                }}</b-card-title>
              </div>
              <div class="card-body-box card-footer-box">
                <course-price v-if="item?.available_course?.length" class="card-price" compact
                  :course="item.available_course[0]" />
                <b-button v-if="item?.available_course.length > 0" aria-label="تفاصيل الدرس"
                  @click="goToRoute('course', item?.available_course[0]?.id)" size="sm"
                  :to="'/course/' + item?.available_course[0]?.id" variant="brand" class="card-action">تفاصيل</b-button>
                <b-button v-else aria-label="تفاصيل الدرس" size="sm" disabled variant="dark" class="card-action"> قريبـًا</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>

      <!-- ksaKamiyCourses -->
      <b-container class="pt-0">
        <b-row>
          <b-col>
            <div class="header d-flex align-items-center justify-content-center">
              <div class="flex-grow-1 border-top"></div>
              <h4 class="mx-3 font-weight-bold">مواد القدرات</h4>
              <div class="flex-grow-1 border-top"></div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" v-if="ksaKamiyCourses.length == 0">
            <div class="d-flex align-items-center justify-content-center">
              <h4 class="mx-3 ">لا يوجد مواد</h4>
            </div>
          </b-col>
          <b-col cols="6" md="4" lg="3" v-for="item in ksaKamiyCourses" :key="item.id" class="d-flex" style="margin-bottom: 20px;">
            <b-card class="custom-card">
              <img :title="item?.available_course[0]?.name" :src="item.image || placeholderImage" :alt="item.name"
                class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />
              <div class="card-body-box" :title="item?.available_course[0]?.name">
                <b-card-title class="card-title" :title="item?.available_course[0]?.name">{{
                  item?.available_course[0]?.name ?? item.name
                }}</b-card-title>
              </div>
              <div class="card-body-box card-footer-box">
                <course-price v-if="item?.available_course?.length" class="card-price" compact
                  :course="item.available_course[0]" />
                <b-button v-if="item?.available_course.length > 0" aria-label="تفاصيل الدرس"
                  @click="goToRoute('course', item?.available_course[0]?.id)" size="sm"
                  :to="'/course/' + item?.available_course[0]?.id" variant="brand" class="card-action">تفاصيل</b-button>
                <b-button v-else aria-label="تفاصيل الدرس" size="sm" disabled variant="dark" class="card-action"> قريبـًا</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>

      <!-- ksaCourses -->
      <b-container class="pt-0">
        <b-row>
          <b-col>
            <div class="header d-flex align-items-center justify-content-center">
              <div class="flex-grow-1 border-top"></div>
              <h4 class="mx-3 font-weight-bold">المواد السعودية الاكثر طلبا</h4>
              <div class="flex-grow-1 border-top"></div>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" v-if="ksaCourses.length == 0">
            <div class="d-flex align-items-center justify-content-center">
              <h4 class="mx-3 ">لا يوجد مواد</h4>
            </div>
          </b-col>
          <b-col cols="6" md="4" lg="3" v-for="item in ksaCourses" :key="item.id" class="d-flex" style="margin-bottom: 20px;">
            <b-card class="custom-card">
              <img :title="item?.available_course[0]?.name" :src="item.image || placeholderImage" :alt="item.name"
                class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />
              <div class="card-body-box" :title="item?.available_course[0]?.name">
                <b-card-title class="card-title" :title="item?.available_course[0]?.name">{{
                  item?.available_course[0]?.name ?? item.name
                }}</b-card-title>
              </div>
              <div class="card-body-box card-footer-box">
                <course-price v-if="item?.available_course?.length" class="card-price" compact
                  :course="item.available_course[0]" />
                <b-button v-if="item?.available_course.length > 0" aria-label="تفاصيل الدرس"
                  @click="goToRoute('course', item?.available_course[0]?.id)" size="sm"
                  :to="'/course/' + item?.available_course[0]?.id" variant="brand" class="card-action">تفاصيل</b-button>
                <b-button v-else aria-label="تفاصيل الدرس" size="sm" disabled variant="dark" class="card-action"> قريبـًا</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>

      <!-- egCourses -->
      <b-container class="pt-0">
        <b-row>
          <b-col>
            <div class="header d-flex align-items-center justify-content-center">
              <div class="flex-grow-1 border-top"></div>
              <h4 class="mx-3 font-weight-bold">المواد المصرية الأكثر طلبا</h4>
              <div class="flex-grow-1 border-top"></div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" v-if="egCourses.length == 0">
            <div class="d-flex align-items-center justify-content-center">
              <h4 class="mx-3 ">لا يوجد مواد</h4>
            </div>
          </b-col>
          <b-col cols="6" md="4" lg="3" v-for="item in egCourses" :key="item.id" class="d-flex" style="margin-bottom: 20px;">
            <b-card class="custom-card">
              <img :title="item?.available_course[0]?.name" :src="item.image || placeholderImage" :alt="item.name"
                class="card-img-top img-fluid" style="height: 150px; object-fit: cover;" />
              <div class="card-body-box" :title="item?.available_course[0]?.name">
                <b-card-title class="card-title">{{
                  item?.available_course[0]?.name
                }}</b-card-title>
              </div>
              <div class="card-body-box card-footer-box">
                <course-price v-if="item?.available_course?.length" class="card-price" compact
                  :course="item.available_course[0]" />
                <b-button v-if="item?.available_course.length > 0" aria-label="تفاصيل الدرس"
                  @click="goToRoute('course', item?.available_course[0]?.id)" size="sm"
                  :to="'/course/' + item?.available_course[0]?.id" variant="brand" class="card-action">تفاصيل</b-button>
                <b-button v-else aria-label="تفاصيل الدرس" size="sm" disabled variant="dark" class="card-action">قريبـًا</b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-container>

    </div>
  </section>
</template>

<script>
import { sendRequest } from "../utils/RequestHelper.js";
import placeholderImg from '@/assets/images/placeholder.png';
import CoursePrice from "../components/courses/CoursePrice.vue";

export default {
  components: { CoursePrice },
  data() {
    return {
      pageIsLoading: true,
      selectedCountry: 1,
      educationLevels: [],
      grades: [],
      placeholderImage: placeholderImg,
      terms: [],
      selectedLevel: null,
      selectedGrade: null,
      selectedTerm: null,
      courses: [],
      egCourses: [],
      ksaCourses: [],
      ksaTahsiliCourses: [],
      ksaKamiyCourses: [],
      formdata: [],
      filtered: false,
      showerror: false,
      alertCountdown: 0,
      alertType: '',
      alertText: '',
    };
  },
  methods: {
    goToRoute(route, id) {
      this.$router.push({ name: route, params: { id: id } });
    },

    loadFilteredData() {
      // if (this.selectedTerm == null || this.selectedGrade == null || this.selectedLevel == null) {
      //   this.filtered = false;
      //   this.showerror = true
      //   setTimeout(() => {
      //     this.showerror = false
      //   }, 3000);
      // }
      // else {
      this.showerror = false
      this.pageIsLoading = true;
      this.courses = []
      this.egCourses = []
      this.ksaCourses = []
      let filter = '?page=1&limit=999'
      // if (this.selectedTerm != null && this.selectedGrade != null && this.selectedLevel != null) {
      if (this.selectedTerm != null) filter += '&semester=' + this.selectedTerm
      if (this.selectedGrade != null) filter += '&grade=' + this.selectedGrade
      if (this.selectedLevel != null) filter += '&stage=' + this.selectedLevel
      if (this.selectedCountry != null) filter += '&country=' + Number(this.selectedCountry + 1)
      this.filtered = true
      // }
      this.pageIsLoading = true;
      sendRequest('get', 'courses/subjects/' + filter, false, {},
        (data) => {
          this.courses = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
      // }

    },
    loadData() {
      this.pageIsLoading = true;
      this.courses = []
      this.egCourses = []
      this.ksaCourses = []
      this.ksaTahsiliCourses = []
      this.ksaKamiyCourses = []
      var filter = '?page=1&limit=8'

      // eg courses
      filter += '&country=' + 1
      this.filtered = false

      this.pageIsLoading = true;
      sendRequest('get', 'courses/subjects/' + filter, false, {},
        (data) => {
          this.egCourses = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );


      // ksa courses
      var filter = '?page=1&limit=8'

      filter += '&country=' + 2
      this.filtered = false

      this.pageIsLoading = true;
      sendRequest('get', 'courses/subjects/' + filter, false, {},
        (data) => {
          this.ksaCourses = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );

      // ksa tahsili courses
      var filter = '?page=1&limit=8&is_tahsili=true'

      filter += '&country=' + 2
      this.filtered = false

      this.pageIsLoading = true;
      sendRequest('get', 'courses/subjects/' + filter, false, {},
        (data) => {
          this.ksaTahsiliCourses = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );


      // ksa kamiy courses
      var filter = '?page=1&limit=8&is_kamiy=true'

      filter += '&country=' + 2
      this.filtered = false

      this.pageIsLoading = true;
      sendRequest('get', 'courses/subjects/' + filter, false, {},
        (data) => {
          this.ksaKamiyCourses = data;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    },

    countDownChanged(alertCountdown) {
      this.alertCountdown = alertCountdown
    },
    submitForm() {
      this.loadFilteredData();
    },
    loadformdata(countryId) {
      this.pageIsLoading = true;

      sendRequest('get', 'courses/education-stages/', false, {},
        (data) => {
          this.formdata = data.filter(item => item.country === countryId);

          this.educationLevels = this.formdata.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.educationLevels.unshift({
            value: null,
            text: 'الكل'
          })
          this.selectedLevel = null;
          this.selectedGrade = null;
          this.selectedTerm = null;
          this.grades = [];
          this.terms = [];

          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
        }
      );
    },

    updateGrades() {
      this.filtered = false
      const selectedStage = this.formdata.find(item => item.id === this.selectedLevel);

      if (selectedStage) {
        this.grades = selectedStage.grades.map(grade => ({
          value: grade.id,
          text: grade.name
        }));
        this.grades.unshift({
          value: null,
          text: 'الكل'
        })
        this.selectedGrade = this.grades[0].value
      } else {
        this.grades = [];
      }

      this.terms = [];
    },

    updateTerms() {
      this.filtered = false
      const selectedStage = this.formdata.find(item => item.id === this.selectedLevel);
      if (selectedStage) {
        const selectedGrade = selectedStage.grades.find(grade => grade.id === this.selectedGrade);

        if (selectedGrade) {

          this.terms = selectedGrade.semesters.map(term => ({
            value: term.id,
            text: term.name
          }));
          this.terms.unshift({
            value: null,
            text: 'الكل'
          })
          this.selectedTerm = this.terms[0].value
        } else {
          this.terms = [];
        }
      } else {
        this.terms = [];
      }
    }
  },

  created() {
    if (this.$route.query.transaction_status) {
      if (this.$route.query.transaction_status == 'SUCCESSFUL') {
        this.alertType = "success"
        this.alertText = "تم الاشتراك بنجاح"
        this.alertCountdown = process.env.VUE_APP_ALERT_COUNTDOWN;
      } else if (this.$route.query.transaction_status == 'FAILED') {
        this.alertType = "danger"
        this.alertText = "فشل الاشتراك .. حاول مرة اخري او اتصل بالادارة"
        this.alertCountdown = process.env.VUE_APP_ALERT_COUNTDOWN;
      }
    }
    this.loadformdata(1);
    this.loadData();
  }
};
</script>

<style scoped>
.courses-form-section {
  background-size: cover;
  background-position: center;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../assets/images/courses/courses_form_bg.jpg');
}

.courses-form-section .custom-card {
  background: rgba(255, 255, 255, 0.9);
  border: 2px solid var(--brand-teal);
  border-radius: 15px;
}

.courses-form-section .flag-icon {
  width: 30px;
  margin-right: 5px;
}

.header {
  margin: 70px 0;
}

.header .border-top {
  border-top: 5px solid black !important;
}

.courses-list-section .custom-card {
  margin-bottom: 20px !important;
  padding: unset !important;
  border: 3px solid #eaeaea !important;
  border-radius: 0 0 10px 10px;
  width: 100%;
}

.card-body {
  padding: 10px;
}

/* equal-height cards: footer (price + action) pinned to the bottom */
.courses-list-section .custom-card ::v-deep .card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.courses-list-section .card-footer-box {
  margin-top: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.courses-list-section .card-price {
  justify-content: flex-start;
  text-align: start;
}

.courses-list-section .card-action {
  margin-inline-start: auto;
  white-space: nowrap;
}

.courses-list-section .card-body-box {
  padding: 10px 10px !important;
}

.courses-list-section .card-body-box .card-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  font-size: 18px;
  max-height: 3em;
  /* 2 lines * line-height */
  position: relative;
}

.courses-list-section .card-body-box .card-title::after {
  content: '\A\A';
  /* forces 2 line breaks if content is less */
  white-space: pre;
  visibility: hidden;
  display: block;
}

/* mobile: two cards per row */
@media (max-width: 575.98px) {
  .header {
    margin: 32px 0;
  }

  .header h4 {
    font-size: 1.2rem;
  }

  .courses-list-section .row > [class*="col-"] {
    padding-left: 6px;
    padding-right: 6px;
  }

  .courses-list-section ::v-deep .card-body {
    padding: 6px;
  }

  .courses-list-section .card-img-top {
    height: 110px !important;
  }

  .courses-list-section .card-body-box {
    padding: 8px !important;
  }

  .courses-list-section .card-body-box .card-title {
    font-size: 15px;
  }

  .courses-form-section .flag-icon {
    width: 22px;
  }
}

/* tablet */
@media (min-width: 768px) and (max-width: 991px) {
  .container {
    margin: 20px 0px;
    max-width: unset;
  }
}
</style>
